import clsx from 'clsx';
import React, { useMemo } from 'react';

var _path;
var BUTTON_HEIGHT = {
  large: 44,
  medium: 36,
  small: 28,
  tiny: 24
};
var TUXButton = function TUXButton(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      onClick = _ref.onClick,
      onDisabledButtonClick = _ref.onDisabledButtonClick,
      text = _ref.text,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      width = _ref.width,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var iconSize = size === 'tiny' ? 12 : 20;
  var buttonClass = useMemo(function () {
    return clsx('tux-button box-border flex select-none appearance-none outline-none cursor-pointer border-solid rounded items-center justify-center px-0 relative w-full', (size === 'medium' || size === 'small') && 'P1-SemiBold', className, {
      'primary': disabled ? 'text-color-TextQuaternary background-color-BGInput2 border-0' : 'text-color-ConstTextInverse background-color-Primary border-0',
      'secondary': disabled ? 'text-color-TextQuaternary background-color-BGTertiary2 border border-color-LineSecondary2' : 'text-color-TextPrimary background-color-BGTertiary2 border border-color-LineSecondary2',
      'const-secondary': 'text-color-ConstTextInverse background-color-ConstBGContainer border-0 tux-button--const-secondary'
    }[variant], {
      'large': 'H4-SemiBold',
      'tiny': 'P3-SemiBold'
    }[size]);
  }, [className, disabled, size, variant]);
  var loadingIcon = useMemo(function () {
    if (!isLoading) {
      return null;
    }

    var loadingIconSize = 24;

    if (size === 'small') {
      loadingIconSize = 20;
    } else if (size === 'tiny') {
      loadingIconSize = 12;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "absolute flex items-center justify-center",
      style: {
        left: 8,
        right: 8,
        top: 0,
        bottom: 0
      }
    }, /*#__PURE__*/React.createElement("svg", {
      className: "tux-button__loading",
      style: {
        fontSize: loadingIconSize
      },
      fill: "currentColor",
      width: "1em",
      height: "1em",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg"
    }, _path || (_path = /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 12.5a11.5 11.5 0 107.4 20.31 2.5 2.5 0 113.2 3.83A16.5 16.5 0 1140.5 24a2.5 2.5 0 01-5 0A11.5 11.5 0 0024 12.5z"
    }))));
  }, [isLoading, size]);
  var buttonHeight = BUTTON_HEIGHT[size];

  var onButtonInnerClick = function onButtonInnerClick(e) {
    if (!disabled || onDisabledButtonClick === undefined) {
      return;
    }

    onDisabledButtonClick(e);
  };

  return /*#__PURE__*/React.createElement("button", {
    className: buttonClass,
    onClick: onClick,
    disabled: disabled || isLoading,
    style: {
      height: buttonHeight,
      minWidth: minWidth,
      maxWidth: maxWidth,
      width: width
    }
  }, isLoading ? loadingIcon : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full px-8",
    onClick: onButtonInnerClick
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: Boolean(text) ? 'me-4' : "",
    style: {
      fontSize: iconSize,
      lineHeight: 0
    }
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: "truncate",
    style: {
      lineHeight: "".concat(buttonHeight, "px")
    }
  }, text)));
};

export { TUXButton };
//# sourceMappingURL=TUXButton.js.map
